export default __webpack_public_path__ + "static/media/desaparecido.badcb6a4.png";